import type { Suggestion } from '@/state';

type SuggestionLike = Pick<Suggestion, 'metadata'>;

export type SuggestionDecision = 'accept' | 'reject';
export type SuggestionMutation = 'acceptSuggestion' | 'removeSuggestion';

const isProofreaderSuggestion = (suggestion?: SuggestionLike): boolean => suggestion?.metadata?.type === 'proofreader';

export const getSuggestionMutation = (decision: SuggestionDecision, suggestion?: SuggestionLike): SuggestionMutation => {
  if (decision === 'accept') {
    return isProofreaderSuggestion(suggestion) ? 'acceptSuggestion' : 'removeSuggestion';
  }

  return isProofreaderSuggestion(suggestion) ? 'removeSuggestion' : 'acceptSuggestion';
};

export const getBulkSuggestionMutation = (
  decision: SuggestionDecision,
  suggestions: SuggestionLike[]
): SuggestionMutation | null => {
  const firstSuggestion = suggestions[0];
  if (!firstSuggestion) return null;

  return getSuggestionMutation(decision, firstSuggestion);
};

export const getNextSuggestionIndex = (currentIndex: number, nextSuggestionsLength: number): number =>
  nextSuggestionsLength > 0 ? Math.min(currentIndex, nextSuggestionsLength - 1) : 0;

export const getContentChangedAfterResolution = ({
  decision,
  hasAcceptedBefore,
}: {
  decision: SuggestionDecision;
  hasAcceptedBefore: boolean;
}): boolean => (decision === 'accept' ? true : hasAcceptedBefore);
